<template>
	<div>
	<div class="clearfix headerTag" v-show='callBack'>
		<a class="fl arror" href="javascript:history.go(-1)" >返回</a>
		<div style="width: 8.46rem;">
			<span  :class="[{ headTit: resultFull }]" :style="{'margin-left':resultFull?'0.7rem':'-0.7rem'}">购车计算器</span>
			<div v-show="resultFull" class="fr" @click="send(1)">发送到手机</div>
		</div>
	</div>
	<div  class="tabView">
	  <!--<div :class="['tabLeft','tabPos',{ tabColor: isActiveLeft }]" @click="leftFull" >
		  全款
	  </div>
	  <div class="verticalLine"></div>
	  <div  :class="['tabRight','tabPos',{ tabColor: isActiveRight }]"  @click="rightLoad" >
		  贷款
	  </div>-->
	  <div class="flexbox">
		  <div :class="['tabLeft','tabPos',{ tabColor: isActiveLeft }]" @click="leftFull" >
			  全款
		  </div>
		  <div :class="[{colorLine: isActiveLeft}]"></div>
	  </div>
	  <div class="verticalLine"></div>
	  <div class="flexbox">
		  <div  :class="['tabRight','tabPos',{ tabColor: isActiveRight }]"  @click="rightLoad" >
			  贷款
		  </div>
		  <div :class="[{colorLine: isActiveRight}]"></div>
	  </div>
	</div>
	<div v-show="!resultFull"><fullSectionComponent v-on:childByValueFull="childValueFull" ref="choiceFull"></fullSectionComponent></div>
	<div v-show="resultFull"><fullInformationComponent v-on:childFullInfo="childFullInfor" ref="choiceFullInfo"></fullInformationComponent></div>
	<markCComponent   ref="choicecar"></markCComponent>
	<markPComponent ref="choicePay"></markPComponent>
	<markYComponent  ref="choiceYear"></markYComponent>
	<markIComponent  ref="choiceInsu"></markIComponent>
	<markTComponent  ref="choiceTax"></markTComponent>
	</div>
</template>

<script>
export default {
  name: 'page-navbar1',
 
  data() {
    return {
      isActiveLeft:true,
      isActiveRight:false,
      loadContent:false,
      resultFull:false,
      buyType:0,
      brandNameShare:'',
	  styleNameShare:'',
	  styleSeriesNameShare:'',
	  id:'',
	  totalPrice:'',
	  carPrice:'',
	  necPrice:'',
	  vehiclePurchaseTaxes:'',
	  vehicleVesselTax:'',
	  sali:'',
	  regPrice:'',
	  urlData:'/mapply/calcuShare',
	  shareInfo: {
		maintitle: '',
		shareUrl: '',
		imgUrl:'',
		remark:''
	  },
	  callBack:true,
    };
  },
	watch:{
			brandNameShare:function(val){
				var self = this;
				this.brandNameShare = val;
			},
			styleNameShare:function(val){
				var self = this;
				this.styleNameShare = val;
			},
			styleSeriesNameShare:function(val){
				var self = this;
				this.styleSeriesNameShare = val;
			}
	},
//watch: {
//    selected: function (val, oldVal) {
//      console.log(val)
//      // click后打印出当前mt-tab-item的id
//    }
//},
  mounted:function(){
		var self = this;
		getCommonJsIns.initCSSNEW();
		getCommonJsIns.initSingleCSSNEW({
			cssURL: "/css/mapply/calculator/index.css?v=123"
		});
		/***统计添加**/
			! function(e, t, n, g, i) {
				e[i] = e[i] || function() {
					(e[i].q = e[i].q || []).push(arguments)
				};
				var n = t.createElement("script");
				var tag = t.getElementsByTagName("script")[0];
				n.async = 1;
				n.src = ('https:' == document.location.protocol ? 'https://' : 'http://') + g;
				tag.parentNode.insertBefore(n, tag);
			}(window, document, "script", "assets.growingio.com/2.1/gio.js", "gio");
			gio('init', '8004d11f5708cccc', {});
			//custom page code begin here
			//custom page code end here
			gio('send');
			gio('enableHT', 'true');
			/***统计添加**/
			/*******************/
			
		    /*添加sid统计代码*/
//			var script=document.createElement('script');
//	        script.type="text/javascript";
//	        script.id = "td_tracking_sdk";
//	        script.vn = "1";
//	        script.vc = "2";
//	        script.src = this.commmonWebConfig.static+"/js/stat/sid.js";
//	        document.body.appendChild(script);
		//确保重要依赖的js加载完成
		getCommonJsIns.initJSNEW(this.webReady);
		
  },
  methods:{
  	webReady:function(){
  		var self = this;
  		document.title='购车计算器';
//		if(self.$route.query.source==22||self.$route.query.source==24){
//			self.callBack=false;
//		}
  		if(self.$route.query.hiddenNav==1){
  			self.callBack=false;
  		}
//		self.shareInfo.maintitle='我正在使用团车购车计算器，一键计算最终购车总价，你也来试试吧！';
//		self.shareInfo.shareUrl= window.location.href;
//		self.shareInfo.imgUrl="https://" + window.location.host + "/wxbargain/static/img/share.jpg?v=1";
//		self.shareInfo.remark='我正在使用团车购车计算器，一键计算最终购车总价，你也来试试吧！';
//		self.initShare();
		self.shareWeb();
  	},
//	initShare:function() {
//		var self = this;
//		webCommonUtil.wechatShare.init({
//			weChatShareInfo: {
//				code: 200,
//				result: {
//					mainTitle: self.shareInfo.maintitle,
//
//					shareUrl: self.shareInfo.shareUrl,
//
//					remark: self.shareInfo.remark,
//
//					imgUrl: self.shareInfo.imgUrl,
//
//				},
//				callback: function() {}
//			}
//		}, wx)
//	},
	shareWeb: function(shareUrl) {
		var self = this;
//		var curHref = "window.location.host";
		var mainTitle = "";
//		var shareUrl = "";
		var remark = "";
//		var brandName = self.brandNameShare;
//		var styleName = self.styleNameShare;
//		var styleSeriesName = self.styleSeriesNameShare;
//		var id = self.id;
		
		var shareImgHeader= "https://" + window.location.host + "/static/img/nubIcon.png?v=1";
//		if(self.resultFull==true&&(self.brandNameShare!=''||self.styleNameShare!=''||self.styleSeriesNameShare!='')){
//			self.shareInfo.mainTitle='我在团车购车计算器算出了'+self.brandNameShare+self.styleNameShare+self.styleSeriesNameShare+'的最终实际购买价格';
//			self.shareInfo.shareUrl= window.location.host+ '/mapply/calcuShare?id='+self.id;
//			self.shareInfo.remark='邀请你来看看购买一辆'+self.brandNameShare+self.styleNameShare+self.styleSeriesNameShare +'，实际总共需要多少钱';
//      }else{
		self.shareInfo.mainTitle='我正在使用团车购车计算器，一键计算最终购车总价，你也来试试吧！';
		if(shareUrl){
//			self.shareInfo.shareUrl= shareUrl+'?totalPrice='+self.totalPrice+'&carPrice='+self.carPrice+'&carPrice='+self.carPrice+'&necPrice='+self.necPrice+'&vehiclePurchaseTaxes='+self.vehiclePurchaseTaxes+'&vehicleVesselTax='+self.vehicleVesselTax+'&sali='+self.sali+'&regPrice='+self.regPrice;
			self.shareInfo.shareUrl= "https://" +window.location.host+shareUrl+'?id='+self.id;
		}else{
			self.shareInfo.shareUrl= window.location.href;
		}
		self.shareInfo.remark='我正在使用团车购车计算器，一键计算最终购车总价，你也来试试吧！';
//		}
		webCommonUtil.wechatShare.init({
			weChatShareInfo: {
				code: 200,
				result: {
					mainTitle: self.shareInfo.mainTitle,

					shareUrl: self.shareInfo.shareUrl,

					remark: self.shareInfo.remark,

					imgUrl: shareImgHeader

				},
				callback: function() {
//					alert(1232);
				}
			}
		}, wx)
		console.log(self.shareInfo.shareUrl+'2222');
	  		console.log(self.shareInfo.mainTitle+'2222');
	  		console.log(shareImgHeader+'2222');
	  		console.log(self.shareInfo.remark+'2222');
	},
	leftFull:function(){
		var self =this;
		this.isActiveLeft=true;
		this.isActiveRight=false;
		this.loadContent=false;
		this.buyType=0;
		if(this.resultFull){
			this.$refs.choiceFullInfo.initFullInfo(self.loadContent,self.resultFull,self.buyType);
		}else{
			this.$refs.choiceFull.initFull(self.loadContent,self.resultFull,self.buyType);
		}

	},
	rightLoad:function(){
		var self =this;
		this.isActiveRight=true;
		this.isActiveLeft=false;
		this.loadContent=true;
		this.buyType=1;
		if(this.resultFull){
			this.$refs.choiceFullInfo.initFullInfo(self.loadContent,self.resultFull,self.buyType);
		}else{
			this.$refs.choiceFull.initFull(self.loadContent,self.resultFull,self.buyType);
		}
	},
	childValueFull:function(data){
		var self=this;
		if(data.state==1){
			this.$refs.choicecar.initSide(self.loadContent,self.resultFull);
		}else if(data.state==2){
			self.resultFull=data.pageStatus;
			self.loadContent=data.showLoadinfo;
//			debugger
			self.brandNameShare=data.brandName;
	        self.styleNameShare=data.styleName;
	        self.styleSeriesNameShare=data.styleSeriesName;
	        self.id=data.id;
//	        self.buyType=data.buyTypes;
//  		self.totalPrice=data.totalPrices;
//  		self.carPrice=data.carPrices;
//  		self.necPrice=data.necPrices;
//  		self.vehiclePurchaseTaxes=data.vehiclePurchaseTaxeses;
//  		self.vehicleVesselTax=data.vehicleVesselTaxs;
//  		self.sali=data.salis;
//  		self.regPrice=data.regPrices;
//	        alert(self.id);
//	        alert(self.brandNameShare);
//	        alert(self.resultFull);
//	        if(self.resultFull==true&&(self.brandNameShare!=''||self.styleNameShare!=''||self.styleSeriesNameShare!='')){
//				self.shareInfo.maintitle='我在团车购车计算器算出了'+self.brandNameShare+self.styleNameShare+self.styleSeriesNameShare+'的最终实际购买价格';
//				self.shareInfo.shareUrl= window.location.host+ '/mapply/calcuShare?id='+self.id;
//				self.shareInfo.imgUrl="https://" + window.location.host + "/wxbargain/static/img/share.jpg?v=1";
//				self.shareInfo.remark='邀请你来看看购买一辆'+self.brandNameShare+self.styleNameShare+self.styleSeriesNameShare +'，实际总共需要多少钱';
//				self.initShare();
//	        }else{
//	  			self.shareInfo.maintitle='我正在使用团车购车计算器，一键计算最终购车总价，你也来试试吧！';
//				self.shareInfo.shareUrl= window.location.href;
//				self.shareInfo.imgUrl="https://" + window.location.host + "/wxbargain/static/img/share.jpg?v=1";
//				self.shareInfo.remark='我正在使用团车购车计算器，一键计算最终购车总价，你也来试试吧！';
//				self.initShare();
//			}
//			debugger
//			self.shareWeb();
//			console.log(self.shareInfo.shareUrl+'1111111111');
//	  		console.log(self.shareInfo.maintitle+'2222222222');
//	  		console.log(self.shareInfo.imgUrl+'333333333333');
//	  		console.log(self.shareInfo.remark+'44444');
			if(self.loadContent){
				self.buyType=1;
			}else{
				self.buyType=0;
			}
			this.$refs.choiceFullInfo.initFullInfo(self.loadContent,self.resultFull,self.buyType);
			
			self.shareWeb(self.urlData);
			console.log(data+"5555555555555555555555")
		}else if(data.state==3){
			this.$refs.choicePay.initSides(self.loadContent,self.resultFull);
		}else if(data.state==4){
			this.$refs.choiceYear.initSideYe(self.loadContent,self.resultFull);
		}
	},
	childFullInfor:function(data){
		var self=this;
		
		if(data.state==1){
			this.$refs.choicecar.initSide(self.loadContent,self.resultFull);
		}
		else if(data.state==2){
			self.brandNameShare=data.brandNames;
	        self.styleNameShare=data.styleNames;
	        self.styleSeriesNameShare=data.styleSeriesNames;
	        self.id=data.ids;
	        self.shareWeb(self.urlData);
		}
//	        self.shareWeb();
//	        if(self.resultFull==true&&(self.brandNameShare!=''||self.styleNameShare!=''||self.styleSeriesNameShare!='')){
//				self.shareInfo.maintitle='我在团车购车计算器算出了'+self.brandNameShare+self.styleNameShare+self.styleSeriesNameShare+'的最终实际购买价格';
//				self.shareInfo.shareUrl= window.location.host+ '/mapply/calcuShare?id='+self.id;
//				self.shareInfo.imgUrl="https://" + window.location.host + "/wxbargain/static/img/share.jpg?v=1";
//				self.shareInfo.remark='邀请你来看看购买一辆'+self.brandNameShare+self.styleNameShare+self.styleSeriesNameShare +'，实际总共需要多少钱';
//				self.initShare();
//	        }else{
//	  			self.shareInfo.maintitle='我正在使用团车购车计算器，一键计算最终购车总价，你也来试试吧！';
//				self.shareInfo.shareUrl= window.location.href;
//				self.shareInfo.imgUrl="https://" + window.location.host + "/wxbargain/static/img/share.jpg?v=1";
//				self.shareInfo.remark='我正在使用团车购车计算器，一键计算最终购车总价，你也来试试吧！';
//				self.initShare();
//			}
//		}
		else if(data.state==3){
			this.$refs.choicePay.initSides(self.loadContent,self.resultFull);
		}else if(data.state==4){
			this.$refs.choiceYear.initSideYe(self.loadContent,self.resultFull);
		}else if(data.state==5){
			this.$refs.choiceInsu.initSideIn(self.loadContent,self.resultFull);
		}else if(data.state==6){
			this.$refs.choiceTax.initSideTa(self.loadContent,self.resultFull);
		}
	},
	send:function(type){
		var self =this;
		this.$refs.choiceFullInfo.initFullInfo(self.loadContent,self.resultFull,self.buyType,type);
	}
  }
};
</script>

<style>
	
</style>


// WEBPACK FOOTER //
// src/views/calculator/index.vue